(() => {
  const root = document.querySelector('[data-cart-builder]');
  if (!root) return;

  const sectionId = root.getAttribute('data-section-id');
  let filter = 'all';
  let busy = false;

  const applyFilter = () => {
    root.querySelectorAll('[data-cart-filters] [data-filter]').forEach((btn) => {
      btn.classList.toggle('active', btn.getAttribute('data-filter') === filter);
    });
    root.querySelectorAll('[data-cart-grid] .bundle-product').forEach((card) => {
      card.hidden = filter !== 'all' && card.getAttribute('data-brand') !== filter;
    });
  };

  const showError = (message) => {
    const el = root.querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  };

  const refreshCartBubble = async () => {
    try {
      const res = await fetch('/?sections=cart-icon-bubble');
      const data = await res.json();
      const target = document.getElementById('cart-icon-bubble');
      if (target && data['cart-icon-bubble']) {
        const doc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        const inner = doc.querySelector('.shopify-section');
        if (inner) target.innerHTML = inner.innerHTML;
      }
    } catch (err) {
      /* non-critical */
    }
  };

  const refreshSection = async () => {
    const res = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-builder]');
    if (next) {
      root.innerHTML = next.innerHTML;
      applyFilter();
    }
    refreshCartBubble();
  };

  const post = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    }
    return res.json();
  };

  root.addEventListener('click', async (event) => {
    const filterBtn = event.target.closest('[data-filter]');
    if (filterBtn) {
      filter = filterBtn.getAttribute('data-filter');
      applyFilter();
      return;
    }

    const addBtn = event.target.closest('[data-add]');
    const lineBtn = event.target.closest('[data-line]');
    if ((!addBtn && !lineBtn) || busy) return;

    busy = true;
    showError('');
    try {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        await post('/cart/add.js', {
          items: [{ id: Number(addBtn.getAttribute('data-add')), quantity: 1 }],
        });
      } else {
        lineBtn.disabled = true;
        await post('/cart/change.js', {
          line: Number(lineBtn.getAttribute('data-line')),
          quantity: Number(lineBtn.getAttribute('data-qty')),
        });
      }
      await refreshSection();
    } catch (err) {
      showError(err.message);
      await refreshSection().catch(() => {});
    } finally {
      busy = false;
    }
  });

  applyFilter();
})();
